import * as React from 'react';

import {
  Datagrid,
  EditButton,
  List,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  TextField,
  useTranslate,
} from 'react-admin';
import { Theme, useMediaQuery } from '@mui/material';

import LinkToRelatedProducts from './LinkToRelatedProducts';
import MobileGrid from './MobileGrid';

const filters = [
  <SearchInput source="q" alwaysOn />,
  <ReferenceInput
    label="Раздел"
    source="section_q"
    reference="sections"
    allowEmpty
    perPage={1000}
  >
    <SelectInput optionText="name" label="Раздел" />
  </ReferenceInput>,
];

const CategoriesList = () => {
  const isXsmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));
  const translate = useTranslate();

  return (
    <List
      bulkActionButtons={false}
      title={translate('pos.menu.categories')}
      filters={!isSmall ? filters : undefined}
    >
      {isXsmall ? (
        <MobileGrid />
      ) : (
        <Datagrid rowClick="edit">
          <TextField
            source="nameTranslated.en"
            label={translate('resources.categories.fields.name')}
          />
          <ReferenceField
            source="section"
            label={translate('resources.categories.fields.section')}
            reference="sections"
          >
            <TextField source="name" />
          </ReferenceField>
          <TextField
            source="order"
            label={translate('resources.categories.fields.order')}
          />
          <LinkToRelatedProducts />
          <EditButton />
        </Datagrid>
      )}
    </List>
  );
};

export default CategoriesList;
